export const WHITELIST = [
  '0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2', // WETH
  '0x6b175474e89094c44da98b954eedeac495271d0f', // DAI
  '0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48', // USDC
  '0xdac17f958d2ee523a2206206994597c13d831ec7', // USDT
  '0x0000000000085d4780b73119b644ae5ecd22b376', // TUSD
  '0x5d3a536e4d6dbd6114cc1ead35777bab948e3643', // cDAI
  '0x39aa39c021dfbae8fac545936693ac917d5e7563', // cUSDC
  '0x86fadb80d8d2cff3c3680819e4da99c10232ba0f', // EBASE
  '0x57ab1ec28d129707052df4df418d58a2d46d5f51', // sUSD
  '0x9f8f72aa9304c8b593d555f12ef6589cc3a579a2', // MKR
  '0xc00e94cb662c3520282e6f5717214004a7f26888', // COMP
  '0x514910771af9ca656af840dff83e8264ecf986ca', // LINK
  '0x960b236a07cf122663c4303350609a66a7b288c0', // ANT
  '0xc011a73ee8576fb46f5e1c5751ca3b9fe0af2a6f', // SNX
  '0x0bc529c00c6401aef6d220be8c6ea1667f6ad93e', // YFI
  '0xdf5e0e81dff6faf3a7e52ba697820c5e32d806a8', // yCurv
  '0x853d955acef822db058eb8505911ed77f175b99e', // FRAX
  '0xa47c8bf37f92abed4a126bda807a7b7498661acd', // WUST
  '0x1f9840a85d5af5bf1d1762f925bdaddc4201f984', // UNI
  '0x2260fac5e5542a773aa44fbcfedf7c193bc2c599', // WBTC
  '0xb31f66aa3c1e785363f0875a1b74e27b85fd66c7', // WAVAX
  '0xe91d153e0b41518a2ce8dd3d7944fa863463a97d', // WXDAI
  '0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c', // WBNB
  '0x21be370d5312f44cb42ce377bc9b8a0cef1a4c83', // WFTM
  '0xA7D7079b0FEaD91F3e65f86E8915Cb59c1a4C664', // USDC.e AVAX
];

export const WHITELIST_SYMBOLS = [
  'WETH',
  'DAI',
  'USDC',
  'USDT',
  'TUSD',
  'cDAI',
  'cUSDC',
  'EBASE',
  'sUSD',
  'MKR',
  'COMP',
  'LINK',
  'ANT',
  'SNX',
  'YFI',
  'yCurv',
  'FRAX',
  'WUST',
  'UNI',
  'WBTC',
  'WAVAX',
  'WXDAI',
  'WBNB',
  'WFTM',
  'USDC.e',
];
